/**
 * Report related apis
 */

import { bytesFromBlob } from './file/fileUtil';
import { downloadReport } from '@/api2/reports';

/**
 * Retrieves a filed report as a document for viewing.
 *
 * `GET /reports/{report}/content`, not pacmny-be's `/file/reports` with action
 * `requestReport`. That pair had no bridge entry — its CDA sibling
 * (`/file/cdas#requestCda`) is mapped and this one and `/file/pdfs` were missed
 * — so opening a report on the routed `/reports` page threw
 * `BridgeUnmappedOperation` and the viewer rendered nothing.
 *
 * The old shape is gone with the old transport. `requestReport` answered HTTP
 * 200 for both outcomes, distinguished by a `status` field, and a base64 blob
 * inside a JSON envelope; a refused read is now a status code and the bytes
 * stream. Callers already treated a rejection as "unable to fetch the report",
 * which is exactly what an `ApiError` now produces.
 *
 * @param {number|string} id id of the report to request
 * @returns {Promise<{report: Uint8Array}>}
 */
export function getReportById(id) {
  return downloadReport(id)
    .then(({ blob }) => bytesFromBlob(blob))
    .then((report) => ({ report }));
}
